import {SizePrice} from './types';

export const calculateFullPrice = (price: SizePrice): number =>
  (price.withTax || 0) +
  (price.saleReduction?.reductionAmountWithTax || 0) +
  (price.campaignReduction?.reductionAmountWithTax || 0) +
  (price.couponReduction?.reductionAmountWithTax || 0);

export const getTrackingPrice = (price: SizePrice | undefined) => {
  if (!price) {
    return {
      withTax: 0,
      withoutTax: 0,
      currency: '',
      saleReductionWithTax: 0,
      campaignReductionWithTax: 0,
      fullPrice: 0,
      couponReductionWithTax: 0,
      coinsReductionWithTax: 0,
    };
  }

  return {
    withTax: price.withTax,
    withoutTax: price.withTax - price.tax,
    currency: price.currencyCode || '',
    saleReductionWithTax: price?.saleReduction?.reductionAmountWithTax || 0,
    campaignReductionWithTax:
      price?.campaignReduction?.reductionAmountWithTax || 0,
    fullPrice: calculateFullPrice(price),
    couponReductionWithTax: 0,
    coinsReductionWithTax: 0,
  };
};
